// extracted by mini-css-extract-plugin
export default {"item":"MenuItem_item__Wjp34","menuItemContainer":"MenuItem_menuItemContainer__5IwCO"};